import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$1, A as ARROW_LEFT_24 } from './mapy-icon3.js';
import { g as getLocale, z as classNames, l as transDialog, k as getTheme } from './utils2.js';
import { k as MAX_PHOTOS_PER_LINE, h as MAX_TEXT_LENGTH, i as LAST_TEXT_LENGTH, d as DIALOG_PAGES } from './const.js';
import { d as defineCustomElement$9 } from './mapy-icon2.js';
import { d as defineCustomElement$8 } from './mapy-loader2.js';
import { d as defineCustomElement$7 } from './mapy-review-button2.js';
import { d as defineCustomElement$6 } from './mapy-review-dialog-footer2.js';
import { d as defineCustomElement$5 } from './mapy-review-photo-item2.js';
import { d as defineCustomElement$4 } from './mapy-review-photos-upload2.js';
import { d as defineCustomElement$3 } from './mapy-review-stars2.js';
import { d as defineCustomElement$2 } from './mapy-review-textarea2.js';

const mapyReviewDialogPageTextPhotoCss = ".mapy-review-dialog-page-text-photo{padding:0;display:flex;flex-direction:column;position:relative;height:100%;overflow:hidden;border-radius:12px}.header{display:flex;gap:8px;flex-direction:column;align-items:center;justify-content:center;width:100%}.header .title{margin:0;font-size:20px;font-style:normal;font-weight:700;line-height:28px;text-align:center;padding:0 25px}.back-button{padding:0;margin:0;position:absolute;left:12px;top:12px;border:none;background:transparent;color:#828282;border-radius:50%;cursor:pointer;z-index:10}.back-button mapy-icon{display:block}.back-button:hover,.back-button:focus{background:#f2f2f2}mapy-review-dialog-footer{width:100%}.textArea{width:100%;box-sizing:border-box}.textArea mapy-review-textarea{width:100%}.photos{width:100%}.scrollable{padding:48px 0 0 0;display:flex;flex-direction:column;gap:24px;justify-content:space-between;height:100%;box-sizing:border-box;font-family:Arial;align-items:center;position:relative;box-sizing:border-box;overflow:auto}.header,.textArea,.photos{width:100%;padding:0 32px;box-sizing:border-box}.footer{width:100%;padding:0 32px;box-sizing:border-box}.mapy-review-dialog-page-text-photo.is-sticky .scrollable{padding-top:23px}.mapy-review-dialog-page-text-photo.is-sticky .footer{position:sticky;left:0;right:0;bottom:0;background:#fff;z-index:10;padding-top:24px;box-shadow:0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2)}@media only screen and (max-width: 500px){.header,.textArea,.photos{width:100%;padding:0 16px;box-sizing:border-box}.footer{width:100%;padding:0 16px;box-sizing:border-box}.scrollable{padding:24px 0 0 0}.mapy-review-dialog-page-text-photo.is-sticky .footer{padding-top:16px}}";
const MapyReviewDialogPageTextPhotoStyle0 = mapyReviewDialogPageTextPhotoCss;

defineCustomElement$1();
const MapyReviewDialogPageTextPhoto = /*@__PURE__*/ proxyCustomElement(class MapyReviewDialogPageTextPhoto extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.signal = createEvent(this, "signal", 1);
        this.back = createEvent(this, "back", 3);
        this.save = createEvent(this, "save", 1);
        this.photoLoading = createEvent(this, "photoLoading", 1);
        this.onBack = () => {
            this.back.emit(this.getSaveData());
        };
        this.onSignal = (signal) => {
            this.signal.emit(signal.detail);
        };
        this.onTextChange = (event) => {
            this.reviewText = event.detail;
        };
        this.onFooterSave = () => {
            this.onSave();
        };
        this.onSave = () => {
            this.save.emit(this.getSaveData());
        };
        this.onUploadStart = (event) => {
            this.photoError = "";
            this.photosAreLoading = true;
            this.photoLoading.emit(true);
            this.signal.emit({
                name: "upload-start",
                count: event.detail,
            });
        };
        this.onPhotosCountChange = (event) => {
            this.isSticky = event.detail > MAX_PHOTOS_PER_LINE;
        };
        this.onPhotosChange = (event) => {
            this.curPhotos = event.detail.photos;
            this.photosAreLoading = false;
            this.photoLoading.emit(false);
        };
        this.onBlurWithText = () => {
            this.signal.emit({
                name: "textarea-blur",
            });
        };
        this.onPhotosError = (event) => {
            this.photoError = event.detail.error;
        };
        this.loading = false;
        this.isFirm = false;
        this.rating = 0;
        this.error = "";
        this.backButton = true;
        this.maxLength = MAX_TEXT_LENGTH;
        this.lastLength = LAST_TEXT_LENGTH;
        this.endpoint = "";
        this.apiKey = "";
        this.text = "";
        this.debug = false;
        this.photos = [];
        this.service = "mapy";
        this.isResponsive = false;
        this.reviewText = "";
        this.isSticky = false;
        this.photosAreLoading = false;
        this.photoError = "";
        this.curPhotos = [];
    }
    getSaveData() {
        return {
            page: DIALOG_PAGES.TEXT_PHOTO,
            text: this.reviewText,
            media_ids: this.curPhotos.map(item => item.mediaId),
            photos: this.curPhotos,
        };
    }
    componentWillLoad() {
        this.reviewText = this.text;
        this.curPhotos = this.photos.slice();
    }
    render() {
        const locale = getLocale(this.hostElement);
        const theme = getTheme(this.service);
        return h(Host, { key: 'f7bd0a85cadc35787667fe35df78d21623c5ba74' }, h("div", { key: '58023aac2c66a8b695e3da236a87ab4b577db50a', class: classNames(["mapy-review-dialog-page-text-photo", this.isSticky || this.isResponsive ? "is-sticky" : ""]) }, (this.backButton && !this.photosAreLoading) && h("button", { key: '13822c53aa363fddaf39cce041180d1d1b844480', type: "button", class: "back-button", onClick: this.onBack }, h("mapy-icon", { key: 'f68dd65e930764a352117e3aa71c13d0df92e501', size: ARROW_LEFT_24.size }, h("path", { key: '717ebe48e40f7a72637ccea79b6e4e073f91668c', d: ARROW_LEFT_24.d }))), h("div", { key: 'b831203ff2a3e8461ed7fe39ca2630d1b6a5e1ce', class: "scrollable" }, h("div", { key: '8276a2a059f0367aa784868a44180477db259d18', class: "header" }, h("mapy-review-stars", { key: 'a74f7cf150d9d425f2eeed310dd4b0a2071113d6', value: this.rating, size: 20, gap: 3, disabled: true }), this.service === "mapy" && h("h3", { key: '7b12c60038c78f67bf68c15a1c53810fab9cd985', class: "title" }, transDialog(locale, "motivateToComment"))), h("div", { key: '4211fae985b026a5f79feba3bb16c60eb642984f', class: "textArea" }, h("mapy-review-textarea", { key: 'ddf147471f6ba08a00fa28b2e155d6fcc616d98a', value: this.reviewText, onChange: this.onTextChange, height: theme === "mapy" ? 154 : 204, maxLength: this.maxLength, lastLength: this.lastLength, lang: locale, service: this.service, onBlurWithText: this.onBlurWithText })), h("div", { key: 'c34397572d54a5602ae60cde0910f03c74ca51f4', class: "photos" }, h("mapy-review-photos-upload", { key: '6b4c85c968bdded3f16f68ab689cbe3cac370593', endpoint: this.endpoint, apiKey: this.apiKey, photos: this.photos, debug: this.debug, onChange: this.onPhotosChange, onError: this.onPhotosError, onCountChange: this.onPhotosCountChange, onUploadStart: this.onUploadStart, lang: locale, service: this.service, onSignal: this.onSignal })), h("div", { key: '8377de96deefb3e4a1ce8e952d04408eb71fed8b', class: "footer" }, h("mapy-review-dialog-footer", { key: '9279c1102b3f0718da62a9363282ffb637d5a55c', isFirm: this.isFirm, hasButton: true, loading: this.loading, disabled: this.loading, lang: locale, service: this.service, hasPhotos: this.curPhotos.length > 0, onSave: this.onFooterSave, onSignal: this.onSignal, afterReview: true, hasReviewText: this.reviewText.length > 0, error: this.photoError || this.error })))));
    }
    get hostElement() { return this; }
    static get style() { return MapyReviewDialogPageTextPhotoStyle0; }
}, [1, "mapy-review-dialog-page-text-photo", {
        "loading": [516],
        "isFirm": [516, "is-firm"],
        "rating": [514],
        "error": [513],
        "backButton": [516, "back-button"],
        "maxLength": [514, "max-length"],
        "lastLength": [514, "last-length"],
        "endpoint": [513],
        "apiKey": [513, "api-key"],
        "text": [513],
        "debug": [516],
        "photos": [16],
        "service": [513],
        "isResponsive": [516, "is-responsive"],
        "reviewText": [32],
        "isSticky": [32],
        "photosAreLoading": [32],
        "photoError": [32],
        "curPhotos": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["mapy-review-dialog-page-text-photo", "mapy-icon", "mapy-loader", "mapy-review-button", "mapy-review-dialog-footer", "mapy-review-photo-item", "mapy-review-photos-upload", "mapy-review-stars", "mapy-review-textarea"];
    components.forEach(tagName => { switch (tagName) {
        case "mapy-review-dialog-page-text-photo":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MapyReviewDialogPageTextPhoto);
            }
            break;
        case "mapy-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "mapy-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "mapy-review-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "mapy-review-dialog-footer":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "mapy-review-photo-item":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "mapy-review-photos-upload":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "mapy-review-stars":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "mapy-review-textarea":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement();

export { MapyReviewDialogPageTextPhoto as M, defineCustomElement as d };

//# sourceMappingURL=mapy-review-dialog-page-text-photo2.js.map